import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { Promotion } from '@/models';
import { CountryCode } from '@/store/ui';
import { ui } from '@/constants';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';
import { AccountPageLoadEvent } from '@/services/analytics/events';

@Component({
  name: 'CmgMemberLoyaltyRewards',
})
export default class CmgMemberLoyaltyRewards extends Vue {
  rewards: Promotion[] = [];
  viewingAll = false;

  get rewardsItems() {
    const { promotions } = this.$appStore.state.customer.wallet;

    return this.viewingAll ? promotions : promotions.slice(0, 3);
  }

  //the full count, regardless of viewingAll
  get rewardsCount() {
    return this.$appStore.state.customer.wallet.promotions.length;
  }

  get isLoggedIn() {
    return this.$services.customer.isLoggedIn() === true;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  get rewardsItemsStyle() {
    return this.rewardsItems.length > 0 ? {} : { justifyContent: 'center' };
  }

  get countryCode(): string {
    return this.$appStore.state.ui.countryProfile.countryCode;
  }

  get userIsGuacMode(): boolean {
    return this.$appStore.getters.isCustomerGuacMode;
  }

  get refreshIcon(): string {
    return this.$appStore.state.cms.images.icons.refreshGold.default;
  }

  get shouldShowRefresh(): boolean {
    return this.$appStore.state.reward.shouldShowRefresh;
  }

  async mounted() {
    if (this.isLoggedIn) {
      this.onRefresh();
    }
  }

  @Watch('isLoggedIn')
  isLoggedInChanged(newLoginState: boolean) {
    if (newLoginState) {
      this.onRefresh();
    }
  }

  onAddReward(event: any) {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: AnalyticsEventAction.AddRewardClick,
      label: AnalyticsEventLabel.AddRewardClick,
    });
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.ui.setModalVisibility('addReward', true);
    this.$services.analytics.send(new AccountPageLoadEvent('rewards-add-rewards'));
    this.$services.ui.firstFocus();
  }

  onRefresh() {
    this.$services.ui.setAppBlur(true);
    this.$services.ui.setAppPepperVisibility(true);
    this.$services.promotions.refreshCustomerPromotions().finally(() => {
      this.$services.ui.setAppBlur(false);
      this.$services.ui.setAppPepperVisibility(false);
    });
  }

  onViewAll() {
    this.viewingAll = true;
    Vue.nextTick(() => this.$services.ui.focusFirstDiv('.rewards-container'));
  }
}
